/**
 * MUI Select for RMA inbound / outbound shipping mode.
 *
 * Reads shipping types from the warehouse shippingTypeSlice (loaded on mount
 * by the containing form via loadShippingTypes). Renders a plain MUI Select
 * with no Formsy dependency.
 */

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { loadShippingTypes } from '@sophocles/features/warehouse/orders/api';
import { shippingTypeSlice } from '@sophocles/features/warehouse/orders/slice';

/**
 * @param {object} props
 * @param {number|string|null} props.value
 * @param {function} props.onChange  - (newValue) => void
 * @param {string} [props.label]
 */
export default function ShippingModeSelect({ value, onChange, label }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const shippingTypes = useSelector(state => shippingTypeSlice.selectors.selectAllEntities(state));
  const resolvedLabel = label ?? t('rma.shippingMode', 'Shipping Mode');

  useEffect(() => {
    if (shippingTypes.length === 0) {
      dispatch(loadShippingTypes());
    }
  }, [dispatch, shippingTypes.length]);

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{resolvedLabel}</InputLabel>
      <Select value={value ?? ''} label={resolvedLabel} onChange={e => onChange(e.target.value || null)}>
        <MenuItem value="">
          <em>{t('rma.none', 'None')}</em>
        </MenuItem>
        {shippingTypes.map(type => (
          <MenuItem key={type.id} value={type.id}>
            {type.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
